export const BREAKPOINT_DELTA = 32;
export const PREVIEW_HORIZONTAL_MARGIN = 40;
export const TABLET_MIN_WIDTH = 834;
export const TABLET_WIDTH = 1024;
export const TABLET_LAPTOP_WIDTH = 1200;
export const DESKTOP_WIDTH = 1440;
export const WIDE_DESKTOP_WIDTH = 1920;
